import React from 'react'
import Icon from 'react-icon-base'

const HomeIcon = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m16 35h-7.7v-15h-4.8l16.3-15 16.2 15h-4.8v15h-7.7v-10h-7.5v10z" />
    </g>
  </Icon>
)

export default HomeIcon
